import {
  FETCHING_VIDEOS_SUCCESS,
  FETCHING_VIDEOS_FAILED,
  FETCHING_VIDEOS,
  CREATING_VIDEOS,
  CREATING_VIDEO_FAILED,
  CREATING_VIDEO_SUCCESS,
  DELETING_VIDEOS,
  DELETING_VIDEOS_COMPLETE,
  DELETING_VIDEOS_FAILED,

  GET_SINGLE_VIDEO,
  GET_SINGLE_VIDEO_COMPLETE,
  GET_SINGLE_VIDEO_FAILED,
} from "./types.js";

import { includes } from 'lodash';

export const initialState = {
  fetchingVideos: false,
  addingVideo: false,
  deletingVideos: false,
  fetchingSingleVideo: false,
  videosToDelete: [],
  videos: {
    data: [],
    page: 1,
    total: 0,
  },
};

export const videosReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SINGLE_VIDEO: return {
      ...state,
      fetchingSingleVideo: true
    }
    case GET_SINGLE_VIDEO_FAILED: return {
      ...state,
      fetchingSingleVideo: false
    }
    case GET_SINGLE_VIDEO_COMPLETE: return {
      ...state,
      fetchingSingleVideo: false,
      videos: {
        ...state.videos,
        data: [action.video, ...state.videos.data]
      }
    }
    case DELETING_VIDEOS: return {
      ...state,
      deletingVideos: true,
      videosToDelete: action.ids
    };
    case DELETING_VIDEOS_FAILED: return {
      ...state,
      deletingVideos: false,
      videosToDelete: []
    }
    case DELETING_VIDEOS_COMPLETE: {
      const ids = action?.ids;
      const updatedVideoList = state?.videos?.data?.filter((video) => {
        const isDeleted = includes(ids, video?.id);
        return !isDeleted;
      });
      return {
        ...state,
        deletingVideos: false,
        videosToDelete: [],
        videos: {
          ...state?.videos,
          data: updatedVideoList,
        },
      };
    }
    case FETCHING_VIDEOS:
      return {
        ...state,
        fetchingVideos: true,
      };
    case FETCHING_VIDEOS_FAILED:
      return {
        ...state,
        fetchingVideos: false,
        videos: {},
      };
    case FETCHING_VIDEOS_SUCCESS:
      return {
        ...state,
        fetchingVideos: false,
        videos: action?.videos,
      };
    case CREATING_VIDEOS:
      return {
        ...state,
        addingVideo: true,
      };
    case CREATING_VIDEO_FAILED:
      return {
        ...state,
        addingVideo: false,
      };
    case CREATING_VIDEO_SUCCESS:
      return {
        ...state,
        addingVideo: false,
        videos: {
          ...state?.videos,
          data: [action?.video, ...state?.videos?.data],
        },
      };
    default:
      return state;
  }
};
